import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-iqac',
  templateUrl: './about-iqac.component.html',
  styleUrls: ['./about-iqac.component.scss']
})
export class AboutIqacComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
